// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-form-cont {\n  max-width: 600px;\n}", "",{"version":3,"sources":["webpack://src/components/users/AddUserPage.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;AAAJ","sourcesContent":["\r\n.add-form-cont {\r\n    max-width: 600px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
